export default __webpack_public_path__ + "static/media/spotify.8f600330.svg";